import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { ListPageWithPersisted, navigateTo } from '../../../../layout/ListPage';
import { ListPageHeader } from '../../../../layout/ListPage/headers';
import LoadingIndicator from '../../../../layout/loading/LoadingIndicator';
import getColumns from './columns';
import useGetItems from './useGetContainedItems';
import useGetContainedItemsPills from './useGetContainedItemsPills';
import useGetOptions from './useGetOptions';

const ContainedItemsPage = () => {
  const { itemId, inventoryId } = useParams();
  const [fetchItems, data = {}, isLoading] = useGetItems({ itemId, inventoryId });
  const [
    getOptions,
    options = {
      containerStatuses: [],
      packagingOptions: [],
      clientInventories: [],
      productTypes: [],
      productSubtypes: [],
      originalVesselProjects: [],
      sites: [],
    },
  ] = useGetOptions();
  const { t } = useTranslation('inventory');
  const { push } = useHistory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getOptions(), []);

  const columns = useMemo(() => {
    const translate = (prefix) => (str) => ({ key: str, value: str, label: t(`${prefix}.${str}`) });
    const fromString = (str) => ({ key: str, value: str, label: str });
    const translatedOption = {
      clientInventories: options.clientInventories.map(fromString),
      productTypes: options.productTypes.map(fromString),
      productSubtypes: options.productSubtypes.map(fromString),
      originalVesselProjects: options.originalVesselProjects.map(fromString),
      containerStatuses: options.containerStatuses.map(translate('containerStatuses')),
      packagingOptions: options.packagingOptions.map(translate('packagings')),
      sites: options.sites.map(fromString),
    };

    return getColumns(translatedOption, t);
  }, [options, t]);

  return (
    <>
      <LoadingIndicator show={isLoading} />
      <div className="pb-4 flex justify-between">
        <h1 className="text-lg inline-block">{t('item.containedItems')}</h1>
      </div>
      <ListPageWithPersisted
        header={ListPageHeader}
        fetcher={fetchItems}
        data={data}
        columns={columns}
        translater={t}
        onRowClick={navigateTo((row) => `/inventory/${row.clientInventory.id}/items/${row.id}`, push)}
        pills={useGetContainedItemsPills(data, t)}
        headerProps={{}}
      />
    </>
  );
};

export default ContainedItemsPage;
